export default {
  name: 'VERY FILM',
  phone: `+49 (0) 160 5510851`,
  legalName: `Obermeier+Strehlow GbR`,
  taxId: `DE298379832`,
  email: `hello@very.film`,
  berlin: {
    title: `Office Berlin`,
    name: `Berlin`,
    street: `Adalbertstr. 86`,
    zip: 10997
  },
  munich: {
    title: `Office Munich`,
    name: `Munich`,
    street: `Humboldtstr. 15`,
    zip: 81543,
    phone: `+49 (0) 160 5572093`
  },
  designBy: {
    name: `Any Studio`,
    url: `http://any.studio`
  },
  codeBy: {
    name: `@spechtperson`,
    url: `http://hirnfaustauge.de`
  }
}



// WEBPACK FOOTER //
// ./src/lib/site.js